// Single source of truth for ending a Spectra session. Used by every
// sign-out button (NavBar, Settings, Profile) so logout behaves identically
// everywhere instead of each button clearing a different subset of keys.
export function endSpectraSession() {
  localStorage.removeItem("spectraUser");
  localStorage.removeItem("spectraToken");
  localStorage.removeItem("spectraAccountId");
  localStorage.removeItem("spectraEmail");
  // Not namespaced per-user, so they'd otherwise leak into the next
  // session on a shared device.
  localStorage.removeItem("spectraTransactions");
  localStorage.removeItem("dashboardData");

  // window.location.replace (not .href) drops the authenticated page from
  // browser history so the back button can't return to it after logout.
  window.location.replace(`${process.env.REACT_APP_AUTH_URL}/signin`);
}
